import { useState } from 'react';
import { FORM_LANGUAGES, type FormLanguage } from '@chat-emp/shared';

const KEY = 'chat-emp.template-language';

function read(): FormLanguage {
  try {
    const stored = localStorage.getItem(KEY);
    return FORM_LANGUAGES.find((language) => language === stored) ?? 'en';
  } catch {
    return 'en';
  }
}

/** The gallery and the shelf read the catalogue in one language, and the choice
 *  outlives the dialog: an employer hiring in Malay does not re-pick it per form.
 *  A preference, not a token — the localStorage invariant is about credentials. */
export function useTemplateLanguage(): [FormLanguage, (language: FormLanguage) => void] {
  const [language, setLanguage] = useState<FormLanguage>(read);
  const choose = (next: FormLanguage) => {
    setLanguage(next);
    try {
      localStorage.setItem(KEY, next);
    } catch {
      // Private mode or a full quota: the choice then lives as long as the page.
    }
  };
  return [language, choose];
}
